import React, { useState } from 'react';
import supabase from '../supabase/supabase';

export default function Settings({ email }) {
  const [recipient, setRecipient] = useState(email || '');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState('');

  async function testEmail(event) {
    event.preventDefault();
    setBusy(true);
    setResult('');
    try {
      const { data, error } = await supabase.functions.invoke('send-work-order-email', {
        body: { action: 'test_email', testEmail: recipient.trim() }
      });

      if (error) {
        let message = data?.error;
        if (!message && error.context instanceof Response) {
          const responseData = await error.context.clone().json().catch(() => null);
          message = responseData?.error;
        }
        throw new Error(message || error.message);
      }
      if (data?.error) throw new Error(data.error);
      setResult(`Test email accepted for ${recipient.trim()}. Check the inbox and spam folder.`);
    } catch (failure) {
      setResult(`Test email failed: ${failure.message}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="crm-panel crm-feature">
      <div className="crm-panel-head"><div><h2>Email delivery test</h2><p>Send a real test message through the configured Emailit Edge Function.</p></div></div>
      <form className="crm-feature-form" onSubmit={testEmail}>
        <label>Recipient email<input type="email" required value={recipient} onChange={(event) => setRecipient(event.target.value)} /></label>
        <button type="submit" disabled={busy}>{busy ? 'Sending…' : 'Send test email'}</button>
      </form>
      {result && <p className="crm-notice" role="status">{result}</p>}
    </section>
  );
}